import React from 'react';
import logoSrc from '../assets/veerny-logo.svg';

/** The violet Veerny logo, for light backgrounds. Decorative: the page says what it is. */
const BrandMark: React.FC<{ width: number; height: number; style?: React.CSSProperties }> = ({ width, height, style }) => (
  <img src={logoSrc} alt="" width={width} height={height} style={{ display: 'block', flex: 'none', ...style }} />
);

export default BrandMark;
